var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M2 11.553C2 16.2761 5.43029 20.2036 9.91667 21V14.1386H7.54167V11.5H9.91667V9.38863C9.91667 7.01363 11.447 5.69471 13.6114 5.69471C14.297 5.69471 15.0364 5.8 15.722 5.90529V8.33333H14.5083C13.347 8.33333 13.0833 8.91363 13.0833 9.65304V11.5H15.6167L15.1947 14.1386H13.0833V21C17.5697 20.2036 21 16.2769 21 11.553C21 6.29875 16.725 2 11.5 2C6.275 2 2 6.29875 2 11.553Z"}));
}

Facebook.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
